<template>
  <kpi-card :value="kpi?.sla" :maxWarningValue="kpi?.threshold" :maxDangerValue="kpi?.critical" :title="$t('home.first_call_resolution_rate')" unit="%" />
</template>

<script>
import KpiCard from "./KpiCard.vue";
export default {
  components: {
    KpiCard,
  },
  props: ["kpi"],
};
</script>

<style></style>
